import {
  Tabs,
  Tab,
  Row,
  Col,
  Form as BForm
} from '@themesberg/react-bootstrap'
import { Formik } from 'formik'
import React from 'react'
import GeneralForm from '../CreateBonus/general'
import useCloneBonus from '../hooks/useCloneBonus'
import useCreateBonus from '../hooks/useCreateBonus'
import { tabLabels } from '../CreateBonus/constants'
import { bonusSchema } from '../CreateBonus/schema'
import PaymentMethod from '../CreateBonus/PaymentMethod'
import CurrenciesForm from '../CreateBonus/currencies'
import WageringContributionForm from '../CreateBonus/wageringContribution'
import Preloader from '../../../../../components/Preloader'
import Games from '../CreateBonus/Games'
import Languages from '../CreateBonus/Languages'
import BonusCountry from '../CreateBonus/BonusCountry'

const CloneBonus = () => {
  const {
    state,
    setState,
    bonusDetail,
    navigate,
    loading,
    data,
    setData,
    handelCreateBonus,
    set,
    countryData,
    setCountryData
  } = useCloneBonus()

  const {
    handleImagePreview,
    preview,
    setActiveTab,
    setCurr,
    enableSubmit,
    setEnableSubmit,
    clientsFilterData,
    setSelectedClient,
    portalOptions,
    getBalanceBonusesOptions,
    balanceBonusOptions,
    dispatch,
    wageringTemplateList,
    wageringTemplateDetail,
    selectedTab,
    setSelectedTab,
    pageNo,
    setPageNo,
    limit,
    setLimit,
    totalPages,
    gameIds,
    setGameIds,
    search,
    setSearch,
    casinoGamesData,
    selectedProvider,
    setSelectedProvider,
    selectedClient,
    gamesLimit,
    gamesPageNo,
    setGamesLimit,
    setGamesPageNo,
    appliedBonusOptions,
    languages,
    loyaltyCount,
    setLoyaltyCount
  } = useCreateBonus()

  return (
    <>
      <Row>
        <Col>
          <h3>Clone Bonus </h3>
        </Col>
      </Row>
      {bonusDetail && !loading && set
        ? (
          <Formik
            enableReinitialize
            initialValues={{
              promotionTitle: bonusDetail?.promotionTitle?.EN || '',
              bonusType: bonusDetail?.bonusType || '',
              validFrom: state.startDate,
              validTo: state.endDate,
              termCondition: bonusDetail?.termCondition?.EN || '',
              quantity: bonusDetail?.quantity || 0,
              daysToClear: bonusDetail?.daysToClear || 0,
              currency: { EUR: bonusDetail?.currency?.EUR } || {},
              maxBonusThreshold: '',
              status: bonusDetail?.status || '',
              minDeposit: '',
              wageringRequirementType: bonusDetail?.wageringRequirementType || '',
              maxWinAmount: '',
              isWinCashAmt: '',
              isBonusWagering: '',
              depositBonusPercent: bonusDetail?.depositBonusPercent,
              tenantIds: [],
              adminId: selectedClient,
              validOnDays: bonusDetail?.validOnDays || [],
              bonusImage: null,
              isActive: bonusDetail?.isActive || false,
              showBonusValidity: bonusDetail?.other?.showBonusValidity,
              visibleInPromotions: bonusDetail?.visibleInPromotions || false,
              isSticky: bonusDetail?.isSticky || false,
              wageringMultiplier: bonusDetail?.wageringMultiplier || 1,
              paymentMethods: {},
              appliedBonusId: '',
              appliedBonusVal: '',
              wageringTemplateId: bonusDetail?.wageringTemplateId || '',
              description: bonusDetail?.description?.EN || '',
              loyaltyLevel: bonusDetail?.other?.loyaltyLevel || [{}],
              minBalance: '',
              timePeriod: bonusDetail?.other?.timePeriod || '1',
              other: bonusDetail?.other?.loyaltyLevel || null,
              betLevel: bonusDetail?.other?.betLevel || 1
            }}
            validationSchema={
            bonusSchema({ EUR: bonusDetail?.currency?.EUR }, { bonusDetail: null })[
              tabLabels.findIndex((val) => val === selectedTab)
            ]
          }
            onSubmit={(formValues) => handelCreateBonus({ formValues, gameIds, languages, selectedTab, setSelectedTab })}
          >
            {({
              touched,
              errors,
              values,
              setSubmitting,
              handleChange,
              handleSubmit,
              handleBlur,
              setFieldValue
            }) => (
              <BForm>
                <Tabs
                  key={selectedTab}
                  activeKey={selectedTab}
                  className='nav-light'
                  mountOnEnter
                  unmountOnExit
                  onSelect={(k) => setSelectedTab(k)}
                >
                  <Tab disabled eventKey='general' title='General'>
                    <div className='mt-5'>
                      <GeneralForm
                        isClone
                        state={state}
                        setState={setState}
                        setSelectedTab={setSelectedTab}
                        touched={touched}
                        errors={errors}
                        values={values}
                        setSubmitting={setSubmitting}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        preview={preview}
                        handleImagePreview={handleImagePreview}
                        navigate={navigate}
                        clientsFilterData={clientsFilterData}
                        setSelectedClient={setSelectedClient}
                        portalOptions={portalOptions}
                        getBalanceBonusesOptions={getBalanceBonusesOptions}
                        balanceBonusOptions={balanceBonusOptions}
                        selectedClient={selectedClient}
                        wageringTemplateList={wageringTemplateList}
                        bonusDetail={bonusDetail}
                        setEnableSubmit={setEnableSubmit}
                        appliedBonusOptions={appliedBonusOptions}
                        setGameIds={setGameIds}
                        data={data}
                        setData={setData}
                        languages={languages}
                        setCountryData={setCountryData}
                      />
                    </div>
                  </Tab>
                  {languages.length > 0 &&
                    <Tab disabled eventKey='languages' title='Languages'>
                      <div className='mt-5'>
                        <Languages
                          languages={languages}
                          handleSubmit={handleSubmit}
                          setSelectedTab={setSelectedTab}
                          selectedTab={selectedTab}
                          data={data}
                          setData={setData}
                          values={values}
                        />
                      </div>
                    </Tab>}
                  {values.bonusType !== 'balance' && values.bonusType !== 'promotion' && (
                    <Tab disabled eventKey='currency' title='Currency'>
                      <div className='mt-5'>
                        <CurrenciesForm
                          touched={touched}
                          errors={errors}
                          values={values}
                          setSubmitting={setSubmitting}
                          handleChange={handleChange}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setCurr={setCurr}
                          setSelectedTab={setSelectedTab}
                          setActiveTab={setActiveTab}
                          enableSubmit={enableSubmit}
                          setEnableSubmit={setEnableSubmit}
                        />
                      </div>
                    </Tab>
                  )}

                  {/* {values.bonusType === 'deposit' && (
                    <Tab
                      disabled
                      eventKey='payment'
                      title='Applies to Payment method'
                    >
                      <div className='mt-3 hhhhh'>
                        <PaymentMethod
                          touched={touched}
                          errors={errors}
                          values={values}
                          setSubmitting={setSubmitting}
                          handleChange={handleChange}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setCurr={setCurr}
                          setSelectedTab={setSelectedTab}
                          setActiveTab={setActiveTab}
                          selectedTab={selectedTab}
                        />
                      </div>
                    </Tab>
                  )} */}
                  {bonusDetail?.bonusType !== 'balance' && (
                    (bonusDetail?.bonusType !== 'freespins') &&
                    values.bonusType !== 'promotion' &&
                    values.bonusType !== 'joining'
                      ? (
                        <Tab
                          disabled
                          eventKey='wageringContribution'
                          title='Wagering contribution'
                        >
                          <div className='mt-5'>
                            <WageringContributionForm
                              state={state}
                              setState={setState}
                              setSelectedTab={setSelectedTab}
                              touched={touched}
                              errors={errors}
                              values={values}
                              setSubmitting={setSubmitting}
                              handleChange={handleChange}
                              handleSubmit={handleSubmit}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              preview={preview}
                              handleImagePreview={handleImagePreview}
                              navigate={navigate}
                              dispatch={dispatch}
                              wageringTemplateList={wageringTemplateList}
                              wageringTemplateDetail={wageringTemplateDetail}
                              setActiveTab={setActiveTab}
                              limit={limit}
                              pageNo={pageNo}
                              setLimit={setLimit}
                              setPageNo={setPageNo}
                              totalPages={totalPages}
                              selectedTab={selectedTab}
                              selectedClient={selectedClient}
                              isClone
                            />
                          </div>
                        </Tab>
                        )
                      : bonusDetail?.isSticky &&
                        <Tab
                          disabled
                          eventKey='wageringContribution'
                          title='Wagering contribution'
                        >
                          <div className='mt-5'>
                            <WageringContributionForm
                              state={state}
                              setState={setState}
                              setSelectedTab={setSelectedTab}
                              touched={touched}
                              errors={errors}
                              values={values}
                              setSubmitting={setSubmitting}
                              handleChange={handleChange}
                              handleSubmit={handleSubmit}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              preview={preview}
                              handleImagePreview={handleImagePreview}
                              navigate={navigate}
                              dispatch={dispatch}
                              wageringTemplateList={wageringTemplateList}
                              wageringTemplateDetail={wageringTemplateDetail}
                              setActiveTab={setActiveTab}
                              limit={limit}
                              pageNo={pageNo}
                              setLimit={setLimit}
                              setPageNo={setPageNo}
                              totalPages={totalPages}
                              selectedTab={selectedTab}
                              selectedClient={selectedClient}
                              isClone
                            />
                          </div>
                        </Tab>

                  )}
                  {(values.bonusType === 'freespins') && (
                    <Tab disabled eventKey='games' title='Games'>
                      <div className='mt-5'>
                        <Games
                          gameIds={gameIds}
                          setGameIds={setGameIds}
                          setLimit={setGamesLimit}
                          setPageNo={setGamesPageNo}
                          setSearch={setSearch}
                          search={search}
                          totalPages={totalPages}
                          limit={gamesLimit}
                          pageNo={gamesPageNo}
                          loading={loading}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          casinoGamesData={casinoGamesData}
                          selectedProvider={selectedProvider}
                          setSelectedProvider={setSelectedProvider}
                          setSelectedTab={setSelectedTab}
                          isEdit
                          errors={errors}
                          values={values}
                        />
                      </div>
                    </Tab>
                  )}
                    {(values.bonusType !== 'joining')&& <Tab disabled eventKey='countries' title='Countries'>
                    <div className='mt-5'>
                      <BonusCountry
                        data={countryData}
                        setData={setCountryData}
                        values={values}
                        setSelectedTab={setSelectedTab}
                        handleSubmit={handleSubmit}
                        languages={languages}
                      />
                    </div>
                  </Tab>}
                </Tabs>
              </BForm>
            )}
          </Formik>
          )
        : <Preloader />}
    </>
  )
}

export default CloneBonus
